import React, { useState } from "react";

const WelcomePopup = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  // ✅ PASTE YOUR FORMSPREE ENDPOINT HERE (SAME AS PROFILEPOPUP)
  // Example: "https://formspree.io/f/mldezpqr"
  const FORMSPREE_ENDPOINT = "https://formspree.io/f/mzzydjej";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    
    if (!email.trim()) {
      setError("Please enter your email");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email");
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      console.log("Submitting to Formspree:", email);
      
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          source: 'Welcome Popup', // ✅ Different source
          timestamp: new Date().toISOString(),
          page: window.location.href
        })
      });

      const data = await response.json();
      
      if (response.ok) {
        console.log("✅ Success:", data);
        alert("Thank you for subscribing! 🎉\nWe'll keep you updated with exclusive offers and new releases.");
        setEmail("");
        onClose();
      } else {
        console.error("❌ Error:", data);
        if (data.error) {
          setError(data.error);
        } else {
          throw new Error('Submission failed');
        }
      }
      
    } catch (error) {
      console.error("❌ Network error:", error);
      setError("Oops! Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        backdropFilter: "blur(4px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10000,
        padding: "20px",
      }}
      onClick={onClose}
    >
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          
          @keyframes slideUp {
            from { transform: translateY(20px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }

          /* ✅ Mobile-specific styles */
          @media (max-width: 768px) {
            .welcome-popup {
              width: 85% !important;
              max-width: 340px !important;
              padding: 24px 20px !important;
            }

            .welcome-popup h2 {
              font-size: 1.4rem !important;
              margin-bottom: 8px !important;
            }

            .welcome-popup .description {
              font-size: 0.85rem !important;
              margin-bottom: 18px !important;
            }

            .welcome-popup input {
              padding: 10px 12px !important;
              font-size: 0.9rem !important;
              margin-bottom: 12px !important;
            }

            .welcome-popup button[type="submit"] {
              padding: 10px !important;
              font-size: 0.95rem !important;
            }

            .welcome-popup .maybe-later {
              margin-top: 10px !important;
              font-size: 0.85rem !important;
            }

            .welcome-popup .close-btn {
              top: 8px !important;
              right: 10px !important;
              font-size: 1.3rem !important;
            }
          }

          @media (max-width: 480px) {
            .welcome-popup {
              width: 90% !important;
              max-width: 320px !important;
              padding: 20px 16px !important;
            }

            .welcome-popup h2 {
              font-size: 1.3rem !important;
            }

            .welcome-popup .description {
              font-size: 0.8rem !important;
            }
          }
        `}
      </style>

      <div
        className="welcome-popup"
        style={{
          backgroundColor: "#fff",
          width: "480px",
          maxWidth: "90%",
          borderRadius: "14px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
          padding: "32px",
          textAlign: "center",
          position: "relative",
          fontFamily: "Inter, sans-serif",
          animation: "slideUp 0.3s ease",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          className="close-btn"
          onClick={onClose}
          style={{
            position: "absolute",
            top: "12px",
            right: "16px",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            cursor: "pointer",
            color: "#888",
            transition: "color 0.3s ease",
            padding: "4px 8px",
            lineHeight: 1,
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#dc814c")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#888")}
        >
          ✕
        </button>

        <h2
          style={{
            fontFamily: "DM Serif Display, serif",
            fontSize: "1.8rem",
            marginBottom: "10px",
            color: "#000",
          }}
        >
          Welcome to SORIN
        </h2>

        <p
          className="description"
          style={{
            fontSize: "1rem",
            color: "#555",
            marginBottom: "24px",
            lineHeight: "1.6",
          }}
        >
          Be the first to know about new scents, exclusive offers, and special releases.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError("");
            }}
            placeholder="Enter your email"
            required
            disabled={isSubmitting}
            style={{
              width: "100%",
              padding: "12px 16px",
              border: error ? "1px solid #f44336" : "1px solid #ddd",
              borderRadius: "8px",
              marginBottom: error ? "8px" : "16px",
              fontSize: "1rem",
              outline: "none",
              transition: "border-color 0.3s ease",
              boxSizing: "border-box",
              opacity: isSubmitting ? 0.6 : 1,
            }}
            onFocus={(e) => {
              if (!error) e.currentTarget.style.borderColor = "#dc814c";
            }}
            onBlur={(e) => {
              if (!error) e.currentTarget.style.borderColor = "#ddd";
            }}
          />

          {error && (
            <p style={{
              color: "#f44336",
              fontSize: "0.85rem",
              marginBottom: "12px",
              textAlign: "left"
            }}>
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            style={{
              width: "100%",
              padding: "12px",
              backgroundColor: isSubmitting ? "#ccc" : "#000",
              color: "#fff",
              fontWeight: "600",
              fontSize: "1rem",
              borderRadius: "8px",
              border: "none",
              cursor: isSubmitting ? "not-allowed" : "pointer",
              transition: "background-color 0.3s ease",
            }}
            onMouseEnter={(e) => {
              if (!isSubmitting) e.currentTarget.style.backgroundColor = "#dc814c";
            }}
            onMouseLeave={(e) => {
              if (!isSubmitting) e.currentTarget.style.backgroundColor = "#000";
            }}
          >
            {isSubmitting ? "Subscribing..." : "Subscribe"}
          </button>
        </form>

        <button
          className="maybe-later"
          onClick={onClose}
          disabled={isSubmitting}
          style={{
            marginTop: "12px",
            background: "none",
            border: "none",
            color: "#888",
            fontSize: "0.9rem",
            cursor: isSubmitting ? "not-allowed" : "pointer",
            textDecoration: "underline",
            transition: "color 0.3s ease",
            opacity: isSubmitting ? 0.5 : 1,
          }}
          onMouseEnter={(e) => {
            if (!isSubmitting) e.currentTarget.style.color = "#dc814c";
          }}
          onMouseLeave={(e) => {
            if (!isSubmitting) e.currentTarget.style.color = "#888";
          }}
        >
          Maybe later
        </button>
      </div>
    </div>
  );
};

export default WelcomePopup;